import { useMemo } from 'react';

import { ApprovalUserType } from 'ui-product-approvals-common';
import type { ApprovalData } from 'ui-product-approvals-common';

import { AuthUser } from '../types/AuthUser';
import { ACTOR } from '../constants/actors';

export const useCurrentUserType = (
  approvalData: ApprovalData,
  currentUser: AuthUser | undefined
): ApprovalUserType =>
  useMemo(() => {
    let result: ApprovalUserType = ApprovalUserType.NON_PARTICIPANT;
    if (!approvalData) {
      return result;
    }
    if (
      approvalData.requester.actor.actorType === ACTOR.USER &&
      approvalData.requester.actor.id === currentUser?.user_id?.toString()
    ) {
      result = ApprovalUserType.REQUESTER;
    } else if (
      approvalData.approvalSteps.length &&
      approvalData.approvalSteps.some(
        (approvalStep) =>
          approvalStep.approver.actor.actorType === ACTOR.USER &&
          approvalStep.approver.actor.id === currentUser?.user_id?.toString()
      )
    ) {
      result = ApprovalUserType.APPROVER;
    }
    return result;
  }, [approvalData, currentUser]);
